import { createSelector } from 'reselect'
import { selectCurrentUserId } from './selectCurrentUserId'

export const selectCurrentUserGlobalId = createSelector(
  selectCurrentUserId,
  id => (id ? `ag_${id}` : id)
)
